export default __webpack_public_path__ + "static/media/RagaDiamonds.22096584.png";